import React from 'react';
import { Box } from '@wix/design-system';
export function NarrowSlimAppBox({ appName = null, appIcon = null, appTeaser = null, topBadge = null, reviewsInfo = null, bottomBadge = null, className, }) {
    return (React.createElement(Box, { className: className, width: "100%", height: "100%", direction: "vertical", align: "space-between" },
        React.createElement(Box, { direction: "vertical", position: "relative" },
            topBadge && (React.createElement(Box, { position: "absolute", top: "-28px", left: "0", zIndex: "1" }, topBadge)),
            React.createElement(Box, { gap: "12px" },
                React.createElement(Box, { flexShrink: 0 }, appIcon),
                React.createElement(Box, { direction: "vertical", width: "100%" },
                    React.createElement(Box, { direction: "vertical", minWidth: 0 },
                        appName,
                        appTeaser),
                    React.createElement(Box, { align: "space-between", verticalAlign: "bottom", marginTop: "2px" },
                        bottomBadge,
                        reviewsInfo))))));
}
//# sourceMappingURL=narrow-slim-app-box.js.map